// PT5 — music LAYERING. Pure helper that decides which extra musical layers are audible for a given combat
// pressure level (from CO4's intensityMix) and whether a boss is active, so the soundtrack evolves over a
// long run (arpeggio fills in, the groove thickens, a boss leitmotif rumbles) instead of looping flat.
// Audio-only, deterministic, headless-testable.

export interface MusicLayers {
  /** sparse arpeggio lead fills in once the fight is busy */
  arp: boolean
  /** the groove thickens (extra octave stab) at high pressure */
  surge: boolean
  /** a low menacing leitmotif while a boss is on the field */
  boss: boolean
}

export function musicLayers(level: number, bossActive: boolean): MusicLayers {
  const l = level < 0 ? 0 : level > 1 ? 1 : level
  return {
    arp: l >= 0.45,
    surge: l >= 0.75,
    boss: !!bossActive,
  }
}
